import { cx } from '@emotion/css';
import React from 'react';
import { Link } from 'react-router-dom';
import EditIcon from "../../assets/images/edit-icon.png";
import '../Card/card-style.css';
import * as styles from './batches.style.js';

function EditBatchCard(props) {
    // function showeditquestions(specificcategory,levels,limits,eventdisplay,category) {
    //      ////console.log("IN Edit event card")
    //      ////console.log(category)
    //       props.showeditquestions(specificcategory,levels,limits,eventdisplay,category);
    // }

    function showeditbatch(id, owner, name, students) {
        ////console.log("showeditbatch")
        ////console.log(id)
        ////console.log(owner)
        ////console.log(name)
        ////console.log(students)
        props.showeditquestions(id, owner, name, students);
    }

    function showdeletebatch(id, owner, name, students) {
        ////console.log(id)
        ////console.log(owner)
        ////console.log(name)
        props.showdeletebatch(id, owner, name, students);
    }
    return (
        <>

            <div className='card text-center shadow'>
                <div className='overflow'>
                    {<Link to={{ pathname: "/editbatch", state: { id: props.id, owner: props.owner, name: props.name, students: props.students, category: props.category } }}>
                        <button className={cx(styles.editBtn)} onClick={() => showeditbatch(props.id, props.owner, props.name, props.students)}  >
                            <img src={EditIcon} alt="" />
                        </button>
                    </Link>}
                    {<img src={props.imgsrc} alt='' className='card-img-top' width="150" height="220" />}
                    <div className='card-body text-dark'>
                        <h4 className='card-text'>{props.name}</h4>
                        <button className="editevenbutton" onClick={() => showdeletebatch(props.id, props.owner, props.name, props.students)}>Delete Batch</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditBatchCard;
